var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-col',{attrs:{"span":24,"md":8}},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.title))]),_c('a-switch',{attrs:{"checked":_vm.checkedStatus},on:{"change":_vm.callAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }